import { FormControl } from '@angular/forms';

export function passwordValidator(control: FormControl): { [invalidPassword: string]: boolean } {
  if (control.value && control.value !== '' && control.value.length < 8) {
    return { invalidPassword: true };
  }

  return null;
}
